(() => {
  const init = (root) => {
    if (root.dataset.arkadasReady) return;
    root.dataset.arkadasReady = 'true';
    const nodes = new Map();
    root.querySelectorAll('*').forEach((node) => {
      for (const attr of node.attributes) if (attr.name.startsWith('data-arkadas-')) nodes.set(attr.name.slice(13), node);
    });
    const field = (name) => nodes.get(name);
    const plaque = root.querySelector('.renao-collage-plaque');
    const fields = field('fields');
    const form = root.closest('form');
    const updatePhotoStep = (count) => {
      const complete = count === 7;
      fields.disabled = !complete;
      fields.hidden = !complete;
      field('step-hint').hidden = complete;
    };
    root.addEventListener('renao:arkadas:photos', (event) => updatePhotoStep(event.detail.count));
    updatePhotoStep(0);
    const search = field('search'), results = field('results'), status = field('status');
    const service = 'https://renao-kargo-takip.onrender.com/apps/renao-spotify';
    let timer, controller, generation = 0;
    const productionAlbumUrl = (url) => String(url || '').replace(
      /(https:\/\/i\.scdn\.co\/image\/ab67616d)(?:00004851|00001e02)/,
      (_, prefix) => `${prefix}0000b273`
    );
    const sync = () => {
      field('title').textContent = field('song').value || 'Our Song';
      field('artist').textContent = field('singer').value || 'Artist name';
      field('lyrics-preview').textContent = field('lyrics').value || 'A few lines\nfrom our\nfavorite song…';
      for (const [image, value] of [['art','art-value'],['code','code-value']]) {
        const url = image === 'art' ? productionAlbumUrl(field(value).value) : field(value).value;
        if (image === 'art' && url) field(value).value = url;
        field(image).hidden = !url;
        if (url && field(image).getAttribute('src') !== url) field(image).src = url;
        if (!url) field(image).removeAttribute('src');
      }
      // Fit the customer's complete excerpt inside the transparent center.
      requestAnimationFrame(() => {
        const lyrics = field('lyrics-preview');
        const width = plaque.getBoundingClientRect().width;
        if (!width) return;
        let size = width * (root.dataset.renaoSourceProductHandle === 'arkadas' ? .0515 : .044);
        lyrics.style.fontSize = `${size}px`;
        while (lyrics.scrollHeight > lyrics.clientHeight + 1 && size > width * .023) {
          size -= .5;
          lyrics.style.fontSize = `${size}px`;
        }
        // Keep cloned proof and print layouts proportional to their own plaque.
        lyrics.style.fontSize = `${size / width * 100}cqw`;
      });
    };
    const select = (track) => {
      const uri = track.spotifyUri || (String(track.spotifyUrl || '').match(/track\/([A-Za-z0-9]+)/)?.[1] ? `spotify:track:${String(track.spotifyUrl).match(/track\/([A-Za-z0-9]+)/)[1]}` : '');
      if (!/^spotify:track:[A-Za-z0-9]+$/.test(uri)) { status.textContent = 'No Spotify code was found for this result. Choose another song.'; return; }
      field('song').value = track.trackName || '';
      field('singer').value = track.artistName || '';
      field('link').value = `https://open.spotify.com/track/${uri.split(':').pop()}`;
      field('art-value').value = track.artworkUrl600 || track.artworkUrl100 || track.artworkUrl60 || '';
      field('code-value').value = `${service}/code?uri=${encodeURIComponent(uri)}&size=1280`;
      search.value = [track.trackName,track.artistName].filter(Boolean).join(' — ');
      results.hidden = true;
      status.textContent = `Selected song: ${search.value}`;
      sync();
      fields.dispatchEvent(new Event('change', {bubbles:true}));
    };
    search.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort(); const requestId = ++generation;
      results.hidden = true;
      const q = search.value.trim();
      if (q.length < 2) { status.textContent = 'Enter at least 2 letters to search.'; return; }
      status.textContent = 'Searching for songs…';
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const response = await fetch(`${service}/search?q=${encodeURIComponent(q)}`, {signal:controller.signal});
          if (!response.ok) throw new Error('search');
          const data = await response.json(); if (requestId !== generation) return;
          results.replaceChildren();
          const tracks = Array.isArray(data.tracks) ? data.tracks : [];
          for (const track of tracks) {
            const button = document.createElement('button'); button.type = 'button'; button.className = 'renao-arkadas-result';
            if (track.artworkUrl60) { const img = document.createElement('img'); img.src = track.artworkUrl60; img.alt = ''; button.append(img); }
            const copy = document.createElement('span'), title = document.createElement('strong'), artist = document.createElement('small');
            title.textContent = track.trackName; artist.textContent = track.artistName;
            copy.append(title,artist); button.append(copy); button.addEventListener('click', () => select(track)); results.append(button);
          }
          results.hidden = !tracks.length;
          status.textContent = tracks.length ? 'Choose your song from the list.' : 'No songs found. Try the song title and artist together.';
        } catch (error) { if (error.name !== 'AbortError' && requestId === generation) status.textContent = 'Songs could not be loaded. Search again.'; }
      }, 350);
    });
    field('lyrics').addEventListener('input', sync);
    root.addEventListener('renao:arkadas:restore', (event) => {
      const props = event.detail || {};
      for (const [key, name] of Object.entries({'Şarkı':'song','Sanatçı':'singer','Şarkı Linki':'link','Albüm Görseli':'art-value','Spotify Kodu':'code-value','Şarkı Sözleri':'lyrics'})) field(name).value = props[`_${key}`] ?? props[key] ?? '';
      search.value = [field('song').value,field('singer').value].filter(Boolean).join(' — ');
      if (search.value) status.textContent = `Selected song: ${search.value}`;
      sync();
    });
    fields.renaoValidate = () => {
      if (!field('song').value || !field('link').value || !field('code-value').value) { search.focus(); return 'Please choose a song from the list.'; }
      if (!field('lyrics').value.trim()) { field('lyrics').focus(); return 'Enter a few lines to show in the center.'; }
      return '';
    };
    new ResizeObserver(sync).observe(plaque);
    sync();
  };
  const boot = () => document.querySelectorAll('[data-renao-collage-personalizer]:is([data-renao-source-product-handle="arkadas"],[data-renao-source-product-handle="arkadas2"])').forEach(init);
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
